import React from 'react';
import Button from '@material-ui/core/Button';
import Link from 'react-router-dom/Link';

const WrappedLink = (props) => (
  <Link {...props} />
);

export default (props) => (
  <Button {...props} component={WrappedLink} />
);



// WEBPACK FOOTER //
// ./src/components/common/ButtonLink/index.js